import { combineReducers } from "redux";

import auth from "./auth";
import videos from "./videos";
import time from "./time";

export default combineReducers({
    auth,
    videos,
    time,
});



// WEBPACK FOOTER //
// ./src/ducks/index.js